module.exports = __webpack_public_path__ + "assets/img/bg-news-desk.png";